import { createTheme } from '@material-ui/core/styles';
import { pink } from '@material-ui/core/colors';

export default createTheme({
  palette: {
    primary: {
      main: pink[900],
    },
  },
});
